import { QSearch } from "./QSearch";
import { QPersonalizedEvents } from "./QPersonalizedEvents";
export const QueryBuilder = {
    search: QSearch,
    personalizedEvents: QPersonalizedEvents
};
//# sourceMappingURL=index.js.map